import React from 'react';
import { compact } from 'lodash';
import { FormattedMessage } from 'react-intl';

import { Strapi_Enum_Componentpagerelatedlist_Relatedlist } from '../../../../graphql-v4.schema';
import { SchoolCardFragment } from '../../../../graphql.schema';
import Divider from '../../../../src/components/Divider';
import SchoolLocationCard from '../../SchoolLocationCard';

export type relatedList = {
  relatedList: Strapi_Enum_Componentpagerelatedlist_Relatedlist;
  relatedSchools?: Array<SchoolCardFragment>;
  schoolSlugBase: string;
};

export const StrapiSchoolsList: React.FC<relatedList> = (props) => {

  const uniqueRelatedSchools = (props?.relatedSchools || []).reduce((acc, school) => {
    if (!acc.some(item => item.documentId === school.documentId)) {
      acc.push(school);
    }
    return acc;
  }, []);
  
  return (
    <>
      <Divider paddingTop="75px" marginBottom="25px">
        <FormattedMessage
          id="totalSchoolsInCity"
          defaultMessage="{total} schools in {city}"
          values={{ total: uniqueRelatedSchools?.length ?? 0, city: props.cityName }}
        />
      </Divider>
      <div>
        {compact(uniqueRelatedSchools)?.map((school, i) => (
          <SchoolLocationCard
            schoolSlugBase={props?.schoolSlugBase ?? ''}
            key={`${school.name}-${i}`}
            mapLocation={school?.mapMarker?.mapLocation}
            {...school}
          />
        ))}
      </div>
    </>
  );
};
